import type {BioIconProps} from '../../icons/common-types'

export default function BestHomeClimatePicksLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M22.6624 9.9344L8.96055 23.6459C8.32078 24.2861 7.22739 24.1399 6.84044 23.3267C6.1466 21.9002 5.74603 20.287 5.74543 18.5937C5.71616 11.2337 13.1806 4.93775 15.7132 3.00352C16.2065 2.63001 16.8731 2.62978 17.3532 3.00294C18.5136 3.88253 20.6875 5.70843 22.7284 8.10771C23.1819 8.64088 23.1555 9.44089 22.6624 9.9344Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M27.3453 18.5993C27.3474 24.546 22.5091 29.3877 16.5491 29.3898C14.1624 29.3907 11.9355 28.6181 10.135 27.2854C9.48153 26.8057 9.42785 25.8457 10.001 25.2721L23.4229 11.8407C24.0493 11.2138 25.1027 11.3468 25.5297 12.12C26.6237 14.1329 27.3578 16.3193 27.3453 18.5993Z"
          fill="white"
        />
      </svg>
      <span>Best Home Climate Picks</span>
    </div>
  )
}
